module.exports = __webpack_public_path__ + "static/media/wave.aecd8aa1.svg";